import { MAP_TYPES } from '@deck.gl/carto';

const STATES_BY_STATENAMES_SOURCE_ID = 'statesByStatenamesSource';

function source(stateNames, year, socioeconomicFactors = []) {
  let whereClause = '';

  year = parseInt(year);

  stateNames.forEach((stateName, index) => {
    if (index === 0) {
      whereClause += 'WHERE (';
    }
    whereClause += `geometry.name = "${stateName}"`;
    if (index < stateNames.length - 1) {
      whereClause += ' OR ';
    } else {
      whereClause += ')';
    }
  });

  whereClause += ` AND observations.year = ${year}`;

  let socioeconomicFactorsParsed =
    socioeconomicFactors.length > 0 ? `, ${socioeconomicFactors.join(', ')}` : '';

  return {
    id: STATES_BY_STATENAMES_SOURCE_ID,
    type: MAP_TYPES.QUERY,
    connection: 'carto_dw',
    data: `
      SELECT
        broadband, geometry.name as statename, year, geom, ST_X(ST_CENTROID(geom)) AS lng, ST_Y(ST_CENTROID(geom)) AS lat, "state" AS type ${socioeconomicFactorsParsed}
      FROM
        carto-dw-ac-cn5bemsi.shared.state_geometries AS geometry
      JOIN
        carto-dw-ac-cn5bemsi.shared.state_observations AS observations ON observations.StateName = geometry.name
      ${whereClause}
    `,
    queryParameters: {
      stateNames,
      year,
    },
  };
}

export default source;
